var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable */
import axios from "axios";
import dayjs from "dayjs";
const apiUrl = process.env.PORTAL_URL || "";
const agendamentoUrl = process.env.AGENDAMENTO_URL || apiUrl;
/**
 * Converte uma data para o formato YYYY-MM-DD
 * @param data - Data em formato DD/MM/YYYY ou YYYY-MM-DD
 * @returns Data formatada ou undefined se inválida
 */
const convertDateToYYYYMMDD = (data) => {
    if (!data)
        return undefined;
    const dataObj = dayjs(data, ["DD/MM/YYYY", "YYYY-MM-DD"]);
    if (!dataObj.isValid())
        return undefined;
    return dataObj.format("YYYY-MM-DD");
};
export function getConfig() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/Configuracoes?fields=*.*`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data[0];
    });
}
export function getDoador(cpf) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/doador?fields=*.*&filter[cpf][_eq]=${cpf}`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data[0];
    });
}
export function getNews() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/posts?limit=3`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getPages() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/Paginas`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getStock() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/Estoque?fields=*.*`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getServiceUnits() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield axios.get(`${apiUrl}/api/hemoes/items/unidades_atendimento`);
        return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
    });
}
export function getSugestaoAgendamento(token, nascimento, cep) {
    return __awaiter(this, void 0, void 0, function* () {
        const formattedDate = convertDateToYYYYMMDD(nascimento);
        const response = yield axios.post(`${agendamentoUrl}/sugestao-agendamento`, {
            dataNascimento: formattedDate,
            servico: "43923c67-0dff-46d0-b47a-f0fb7ad78c6c",
            cep: cep,
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export function enviarAgendamento(token, usuario, data, hora, unidade) {
    return __awaiter(this, void 0, void 0, function* () {
        const formattedDate = convertDateToYYYYMMDD(data);
        const response = yield axios.post(`${agendamentoUrl}/reservar`, {
            usuario: usuario,
            servico: "43923c67-0dff-46d0-b47a-f0fb7ad78c6c",
            data: formattedDate,
            hora: hora,
            unidade: unidade,
        }, { headers: { Authorization: `Bearer ${token}` } });
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export function obterAgendamentoAnterior(token, servicoId) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = axios.create({
            baseURL: agendamentoUrl,
            headers: { Authorization: `Bearer ${token}` },
        });
        const response = yield api.get(`/meus-agendamentos?servico=${servicoId}&ativo=true`);
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export function cancelarAgendamento(token, agendamentoId) {
    return __awaiter(this, void 0, void 0, function* () {
        const api = axios.create({
            baseURL: agendamentoUrl,
            headers: { Authorization: `Bearer ${token}` },
        });
        const response = yield api.post(`/meus-agendamentos/${agendamentoId}/cancelar`);
        return response === null || response === void 0 ? void 0 : response.data;
    });
}
export const checkAgendamentoExistente = (api, servicoId, ativo) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield api.get(`/meus-agendamentos?servico=${servicoId}&ativo=${ativo}`);
    return response.data;
});
export const cancelarAgendamentoWithApi = (api, agendamentoId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield api.post(`/meus-agendamentos/${agendamentoId}/cancelar`);
    return response.data;
});
